import { styled } from "styled-components";

const TitleBox = styled.h3`
  font-size: 32px;
  font-weight: 700;
  padding: 0 23px;
  margin: 26px 0 15px;
`;

export default TitleBox;
